import { ConsumptionLanding } from './components/Landing';
import { RouteObject } from'react-router-dom';

export interface ConsumptionRoute extends Omit<RouteObject,'children'> {
 auth?: boolean;
 children?: ConsumptionRoute[];
}

export const consumptionRoutes:ConsumptionRoute[] = [
 {
 path:'/consumption',
 element: <ConsumptionLanding />,
 },
];
